import axios from "axios"

const actionGetStates = async ({commit}) => {
  const results = await axios.get(`${process.env.VUE_APP_URL_API}/v1/cities`);
  commit("SET_STATES", results.data.data);
}

export default {
  actionGetStates
}